import { makeAutoObservable } from 'mobx'

const DOWNGRADE_REASON_KEY_MAP: Record<string, string> = {
  'I was on the wrong plan': 'wrong_plan',
  'I can no longer afford it / budget reasons': 'budget',
  'My business is seasonal': 'seasonal',
  "I didn't use the credits": 'unused_credits',
  'Too many credits': 'too_many_credits',
  Other: 'other',
}

export class DowngradeContentStore {
  private _selectedReason: string | null = null
  private _reasonDesc = ''

  constructor() {
    makeAutoObservable(this)
  }

  get selectedReason() {
    return this._selectedReason
  }

  get selectedReasonKey(): string | null {
    if (!this._selectedReason) return null
    return DOWNGRADE_REASON_KEY_MAP[this._selectedReason] ?? null
  }

  setSelectedReason = (reason: string) => {
    this._selectedReason = reason
  }

  clearSelectedReason = () => {
    this._selectedReason = null
  }

  get reasonDesc() {
    return this._reasonDesc
  }

  setReasonDesc = (value: string) => {
    this._reasonDesc = value
  }

  clearReasonDesc = () => {
    this._reasonDesc = ''
  }
}
